// Centralized free-gift promotion config.
// Change these values to tweak the promo (or set enabled: false to disable).
export const FREE_GIFT_CONFIG = {
  enabled: true,
  // Display name shown in cart, Stripe checkout, invoices, admin and emails.
  name: "Bezmaksas dāvana: Piekariņš",
  // English label (used only for in-app UI when the user's language is EN).
  nameEn: "Free gift: Keychain",
  // Item price in EUR. Must be 0 for the gift to be free.
  price: 0,
  // Quantity per order — always 1, not editable by the customer.
  quantity: 1,
  // Minimum cart subtotal (EUR, before discount/shipping) to qualify.
  minSubtotal: 50,
} as const;

export type FreeGiftConfig = typeof FREE_GIFT_CONFIG;

export function qualifiesForFreeGift(subtotal: number): boolean {
  return FREE_GIFT_CONFIG.enabled && subtotal >= FREE_GIFT_CONFIG.minSubtotal;
}
